import { render, staticRenderFns } from "./PriceChart.vue?vue&type=template&id=1d4d1200&scoped=true&"
import script from "./PriceChart.vue?vue&type=script&lang=js&"
export * from "./PriceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d1200",
  null
  
)

export default component.exports